export const LogoMark = ({ size = 36, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <rect width="48" height="48" rx="12" fill="#0B192C" />
    <path
      d="M11.5 20.5L24 10.5L36.5 20.5"
      stroke="#FF5C00"
      strokeWidth="4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 30L21.5 35.5L32.5 26.5"
      stroke="#fff"
      strokeWidth="4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Logo = ({ dark = false, size = 36, dataTestId = "brand-logo" }) => (
  <span className="inline-flex items-center gap-2.5" data-testid={dataTestId}>
    <LogoMark size={size} />
    <span
      className={`font-display text-[1.35rem] font-extrabold tracking-tight ${
        dark ? "text-white" : "text-petrol"
      }`}
    >
      resolv
      <span className="text-brand">.</span>
    </span>
  </span>
);
